module.exports = __webpack_public_path__ + "img/标题@2x(3).6b58fe02.png";